import dayjs from "dayjs";

/** `clients.openCaseload` from `GET /reports/executive`. */
export interface OpenCaseload {
  count: number;
  /** YYYY-MM-DD the count is measured at. */
  asOf: string;
  /** True when the count is the live open count (range ends today / no end). */
  live: boolean;
  /** Open cases as of the day before the range start; null for All time. */
  atStart: number | null;
  /** count - atStart; null when atStart is null. */
  netChange: number | null;
}

const DATE_FORMAT = "MMM D, YYYY";

const formatNet = (net: number) => {
  if (net === 0) return "no change";
  // U+2212 MINUS SIGN, not a hyphen, for negative changes.
  return net > 0 ? `+${net}` : `−${Math.abs(net)}`;
};

/**
 * Sub-line for the Executive Dashboard "Open Caseload" tile:
 *   live, no range      → "open cases now"
 *   live, with range    → "open cases now · +29 since Jul 1, 2026"
 *   historical          → "as of Sep 30, 2026" (+ the same "since" suffix)
 */
export const openCaseloadSubtitle = (
  openCaseload: OpenCaseload,
  rangeStart: string | null,
): string => {
  const head = openCaseload.live
    ? "open cases now"
    : `as of ${dayjs(openCaseload.asOf).format(DATE_FORMAT)}`;
  const { netChange } = openCaseload;
  if (netChange == null || !rangeStart) return head;
  return `${head} · ${formatNet(netChange)} since ${dayjs(rangeStart).format(
    DATE_FORMAT,
  )}`;
};
